// import React from 'react';
// import { EmailShareButton, EmailIcon } from 'react-share';

// const ShareAuditOptions = ({ auditUrl }) => {
//     const mail = `${process.env.PUBLIC_URL}/custom-icons/mail-icon.png`;
//     const subject = "Link for self-inspection";
//     const emailBody = `Dear Customer,\nThank you for choosing Surveyor's AI.\n\nYour link for self-inspection is: \n ${auditUrl} \n\nBest regards,\nSurveyor's AI Team`;

//     const message = `Dear Customer, thank you for choosing Surveyor's AI. Your link for self-inspection is ${auditUrl}`;

//     return (
//         <div style={{ display: 'flex', justifyContent: 'center', gap: '20px',width:"100%" }}>
//             <div  style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '65px',
//                     height: '65px',
//                     borderRadius: '50%',
//                     backgroundColor: '#FAFAFA',
//                     textDecoration: 'none',
//                 }}>
//             {/* Email Share Button */}
//             <EmailShareButton
//                 subject={subject}
//                 body={emailBody}
//                 url={""} // You can still provide a URL if needed
//             >
//                 <img src={mail} style={{ width: "1.5rem", height: "1.2rem" }} alt="Share Icon" />
//             </EmailShareButton>
//             </div>

//             {/* Message Option */}
//             <a
//                 href={`sms:?body=${encodeURIComponent(message)}`}
//                 style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '65px',
//                     height: '65px',
//                     borderRadius: '50%',
//                     backgroundColor: '#FAFAFA',
//                     textDecoration: 'none',
//                 }}
//             >
//                 <img src={`${process.env.PUBLIC_URL}/custom-icons/msg-icon.png`} style={{ width: "1.5rem", height: "1.5rem" }} alt="Share Icon" />
//             </a>

//             {/* WhatsApp Option */}
//             <a
//                 href={`https://wa.me/?text=${encodeURIComponent(message)}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '65px',
//                     height: '65px',
//                     borderRadius: '50%',
//                     backgroundColor: '#FAFAFA',
//                     textDecoration: 'none',
//                 }}
//             >
//                 <img src={`${process.env.PUBLIC_URL}/custom-icons/whatsapp-icon.png`} style={{ width: "1.7rem", height: "1.7rem" }} alt="Share Icon" />
//             </a>
//         </div>
//     );
// };

//2
// export default ShareAuditOptions;
import React from 'react';
import { EmailShareButton } from 'react-share';

const ShareAuditOptions = ({ auditUrl }) => {
    const mail = `${process.env.PUBLIC_URL}/custom-icons/mail-icon.png`;
    const subject = "Link for self-inspection";
    const emailBody = `Dear Customer,\nThank you for choosing Surveyor's AI.\n\nYour link for self-inspection is: \n ${auditUrl} \n\nBest regards,\nSurveyor's AI Team`;

    const message = `Dear Customer, thank you for choosing Surveyor's AI. Your link for self-inspection is ${auditUrl}`;
    const openLink = (url) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(url);
        } else {
            window.open(url, "_blank");
        }
    };
    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', width: "100%" }}>

            {/* Email Share Button */}
            {/* <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '65px',
                height: '65px',
                borderRadius: '50%',
                backgroundColor: '#FAFAFA',
                textDecoration: 'none',
            }}>
                <EmailShareButton
                    subject={subject}
                    body={emailBody}
                    url={""} // Added auditUrl here
                >
                    <img src={mail} style={{ width: "1.5rem", height: "1.2rem" }} alt="Share Icon" />
                </EmailShareButton>
            </div> */}
            {/* Email Share Button */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '65px',
                    height: '65px',
                    borderRadius: '50%',
                    backgroundColor: '#FAFAFA',
                    textDecoration: 'none',
                }}
                onClick={() => openLink(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`)}
            >
                <img src={mail} style={{ width: "1.5rem", height: "1.2rem" }} alt="Share Icon" />
            </div>

            {/* SMS Share */}
            <a
                // href={`sms://?body=${encodeURIComponent(message)}`} // Updated URL
                href={`sms:?body=${encodeURIComponent(message)}`}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '65px',
                    height: '65px',
                    borderRadius: '50%',
                    backgroundColor: '#FAFAFA',
                    textDecoration: 'none',
                }}
            >
                <img src={`${process.env.PUBLIC_URL}/custom-icons/msg-icon.png`} style={{ width: "1.5rem", height: "1.5rem" }} alt="Share Icon" />
            </a>


            {/* WhatsApp Share */}
            <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`} // Updated URL
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '65px',
                    height: '65px',
                    borderRadius: '50%',
                    backgroundColor: '#FAFAFA',
                    textDecoration: 'none',
                }}
            >
                <img src={`${process.env.PUBLIC_URL}/custom-icons/whatsapp-icon.png`} style={{ width: "1.7rem", height: "1.7rem" }} alt="Share Icon" />
            </a>

        </div>
    );
};

export default ShareAuditOptions;


// import React from 'react';
// import { EmailShareButton } from 'react-share';

// const ShareAuditOptions = ({ auditUrl }) => {
//     const mail = `${process.env.PUBLIC_URL}/custom-icons/mail-icon.png`;
//     const subject = "Link for self-inspection";
//     const emailBody = `Dear Customer,\nThank you for choosing Surveyor's AI.\n\nYour link for self-inspection is: \n ${auditUrl} \n\nBest regards,\nSurveyor's AI Team`;

//     const message = `Dear Customer, thank you for choosing Surveyor's AI. Your link for self-inspection is ${auditUrl}`;

//     const openLink = (url) => {
//         if (window.ReactNativeWebView) {
//             window.ReactNativeWebView.postMessage(url);
//         } else {
//             window.open(url, "_blank");
//         }
//     };

//     return (
//         <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', width: "100%" }}>
//             {/* Email Share Button */}
//             <div 
//                 style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '65px',
//                     height: '65px',
//                     borderRadius: '50%',
//                     backgroundColor: '#FAFAFA',
//                     textDecoration: 'none',
//                 }}
//                 onClick={() => openLink(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`)}
//             >
//                 <img src={mail} style={{ width: "1.5rem", height: "1.2rem" }} alt="Share Icon" />
//             </div>

//             {/* SMS Share */}
//             <div 
//                 style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '65px',
//                     height: '65px',
//                     borderRadius: '50%',
//                     backgroundColor: '#FAFAFA',
//                     textDecoration: 'none',
//                 }}
//                 onClick={() => openLink(`sms:?body=${encodeURIComponent(message)}`)}
//             >
//                 <img src={`${process.env.PUBLIC_URL}/custom-icons/msg-icon.png`} style={{ width: "1.5rem", height: "1.5rem" }} alt="Share Icon" />
//             </div>

//             {/* WhatsApp Share */}
//             <div 
//                 style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     width: '65px',
//                     height: '65px',
//                     borderRadius: '50%',
//                     backgroundColor: '#FAFAFA',
//                     textDecoration: 'none',
//                 }}
//                 onClick={() => openLink(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`)}
//             >
//                 <img src={`${process.env.PUBLIC_URL}/custom-icons/whatsapp-icon.png`} style={{ width: "1.7rem", height: "1.7rem" }} alt="Share Icon" />
//             </div>
//         </div>
//     );
// };

// export default ShareAuditOptions;
